import { Locale, type LocalizedString } from "../../../schema/Locale.js";
import { cognitoNameToTextMapping } from "../cognito/getExpectedCognitoError.js";
import { AppSyncError } from "./AppSyncError.js";

const errorToMessageMapping: Record<string, LocalizedString> = {
	...Object.fromEntries(Object.entries(cognitoNameToTextMapping).map(([key, value]) => [`${key}:`, value])),
	AccessCodeAlreadyUsed: {
		[Locale.cs]: "Tento kód je již používán.",
	},
	NoMatchingAccessCode: {
		[Locale.cs]: "Neplatný přístupový kód.",
	},
};

function getAppSyncErrorMessage(error: unknown, locale: Locale): string | undefined {
	if (!(error instanceof AppSyncError)) {
		return;
	}

	const [graphqlError] = error.errors;
	if (!graphqlError?.errorType) {
		return;
	}

	return errorToMessageMapping[graphqlError.errorType]?.[locale];
}

export function getExpectedAppSyncError(error: unknown, locale: Locale, fallback?: string): string | undefined {
	const message = getAppSyncErrorMessage(error, locale);
	return message ?? fallback;
}
